import {Component, ElementRef, Input, OnInit, Renderer2, ViewChild , ViewChildren, AfterViewChecked, QueryList} from '@angular/core';
// Services
import {RewardService} from '../../../shared/services/reward.service';
import {RewardsSummaryService} from '../../../shared/services/rewards-summary.service';
import { RewardsToasterService } from '../../../shared/services/rewards-toaster.service';
import { RewardsToasterArgs, RewardsToasterType } from '../../../shared/services/rewards-toaster.interface';
// Data Model
import {RewardModel} from '../../../shared/models/data.model';
import {PaginationService} from '../../../shared/services/pagination.service';
// Infinite Scroll
import {LoaderService} from '../../../shared/loading-spinner/loading-spinner.service';
import {properties} from '../../../../environments/properties';
import {ParamService} from '../../../shared/services/param.service';
import { KeyValue } from '@angular/common';
import {PointRewardCardComponent} from './point-reward-card/point-reward-card.component';


// jQuery
declare const $: any;

@Component({
    selector: 'point-reward-grid',
    templateUrl: './point-reward-grid.component.html',
    styleUrls: ['./point-reward-grid.component.scss']
})

export class PointRewardGridComponent implements OnInit, AfterViewChecked {
    public rewards: RewardModel[] = [];
    public hideloadMoreButton = false;
    public sortedRewards: RewardModel[] = [];  // the whole list
    public rewardsSecondary: RewardModel[] = []; // expanded list
    public catigorizePointsTierRewards: { [key: string]: RewardModel[] };
    public currentPointTier: string;
    public currentCounter: { [key: number]: number };
    public count: { [key: number]: number };
    public counter = [];
    public cashReward: RewardModel[] = []; // cash Reward
    public tempCounter = [];
    public showLoading = true;
    public error = false;
    public rewardDetailPath: string;
    public errorMessage: string;
    public dataErrorMessage: string;
    public isAuthenticated = false;
    public rewardsAvailable: number;
    public pointsAvailable: number;
    public rewardPoints: number;
    public rewardsExpire: number;
    public rewardChecked = '';
    public showAsPromo = '';
    public hideCategories = '';
    public promoGridTitle = '';
    public promoGridLabelTitle = '';
    public promoGridLabelLink = '';

    public strPromoTextPlateDisplay = '';
    public strPromoOpenInNewTab = '';
    public strPromoPosition = '';
    public strPromoImageSrc = '';
    public strPromoAltText = '';
    public strPromoLinkPath = '';
    public strPromoTextPlateHeaderText = '';
    public strPromoTextPlateSubText = '';
    public strPromoTextPlateCTAText = '';

    public promoTextPlateDisplay = false;
    public promoOpenInNewTab = false;
    public promoPosition = 0;

    public isLoadMoreActive = false;
    public loadType = '';
    public loadMoreMobileItems = 0;
    public loadMoreTabletItems = 0;
    public loadMoreDesktopItems = 0;
    public rewardToFocus = 0;
    public rewardCardDisabled = false;
    public disableMulticlipRewardGallery: boolean;
    public disableCashReward: boolean;
    public firstTimeInSession: boolean = false;
    @Input() enableCashReward: boolean;
    @Input() pointScoreCardFlow: boolean;
    @Input() userInfo: any;
    @Input() appHostURL: any;
    @Input() currentEnvironment: any;
    hideGallery = false;
    @Input() banner: any;
    @Input() rewardsResponseObj;
    autoRewardsPoints: number;
    balance: number;
    dollarDiscount: number;
    willExpire: number;
    isUserHasRewards = false;
    pointsExpiryDate: any;
    points: any;
    rewardsPointsValueDetailsDisplay: any;
    rewardsPointsDateDetailsDisplay: any;
    b4UGalleryData: any;
    rewardCardCount = 0;
    @ViewChild('pointsTabsList') tabsList: ElementRef;
    @ViewChildren('rewardCard') rewardList!: QueryList<PointRewardCardComponent>;
    constructor(public _rewardGridService: RewardService,
                private _rewardSummaryService: RewardsSummaryService,
                private elementRef: ElementRef,
                private _rewardsToasterService: RewardsToasterService,
                private _paginationService: PaginationService,
                private _loaderService: LoaderService,
                private paramService: ParamService,
                private _renderer: Renderer2,) {

        this.dataErrorMessage = 'No rewards available for this product';
        this.showAsPromo = 'false';
        this.hideCategories = 'false';
        this.promoGridTitle = '';
        this.promoGridLabelTitle = '';
        this.promoGridLabelLink = '';

        this.strPromoTextPlateDisplay = 'true';
        this.strPromoOpenInNewTab = 'true';
        this.strPromoPosition = '2';
        this.strPromoImageSrc = 'https://images.albertsons-media.com/is/image/ABS/starbucks-banner-full-test';
        this.strPromoAltText = 'Starbucks Drinks';
        this.strPromoTextPlateHeaderText = '<p>Summer Forever</p>';
        this.strPromoTextPlateSubText = '<p>Treat yourself to something special</p>';
        this.strPromoTextPlateCTAText = 'Find a café near you';

        this.promoTextPlateDisplay = this.strPromoTextPlateDisplay === 'true';
        this.promoOpenInNewTab = this.strPromoOpenInNewTab === 'true';
        if (this.strPromoPosition) {
            this.promoPosition = parseInt(this.strPromoPosition, this.promoPosition);
        }
        this.disableCashReward = false;
        /* Load More */
        this.loadMoreMobileItems = 30;
        this.loadMoreTabletItems = 30;
        this.loadMoreDesktopItems = 30;

        this._paginationService.setPaginationNumbers(this.loadMoreMobileItems, this.loadMoreTabletItems, this.loadMoreDesktopItems);
        this.rewardCardDisabled = false;

    }

    ngOnInit() {
        this.banner = this.paramService.banner;
        this.disableMulticlipRewardGallery = properties.rewardsConfig.disableMulticlipRewardGallery;
        this.strPromoLinkPath = 'https://local.'+ this.banner +'.com/search.html';
        this.initSubscribe();
        this._init();
    }

    ngAfterViewChecked() {
        if(this.rewardList.length > this.rewardCardCount) {
            this.rewardList.get(this.rewardCardCount)?.focusOnReward();
            this.rewardCardCount = this.rewardList.length;
        }
    }

    initSubscribe() {
        this._rewardSummaryService.hideGallerySource.subscribe((data) => {
            if (data) {
                this.hideGallery = true;
            } else {
                this.hideGallery = false;
                this._init();
            }
        });
        this._rewardSummaryService.$updateGalleryDetails.subscribe(data => {
            if (data) {
                const b4UGalleryData = JSON.parse(localStorage.getItem('abRewards')).offers;
                let scoreCardData = JSON.parse(localStorage.getItem('scoreCardDetails'));
                this.rewardsResponseObj = scoreCardData;
                if (b4UGalleryData && b4UGalleryData.length > 0) {
                    this.rewards = b4UGalleryData.filter(reward => !!reward.pointsRequired);
                    this.rewards.forEach(offer => {
                        if (offer.groceryRewardId === data.itemId) {
                            this.catigorizeRewardstoPointsTier();
                            this.setScoreCardValueInRewards(scoreCardData);
                            this.currentPointTier = offer.pointsRequired.toString();
                            this.resetLoadMoreRewards(this.currentPointTier);
                        }
                    });
                }

            }
        })
    }

    private _init() {
        this.resetCounters();
        this.b4UGalleryData = JSON.parse(localStorage.getItem('abRewards')).offers || [];
        this.cashReward = JSON.parse(localStorage.getItem('abRewards')).cashOffer;
        if (this.b4UGalleryData.length > 0) {
            this.rewards = this.b4UGalleryData.filter(reward => !!reward.pointsRequired);
            this.catigorizeRewardstoPointsTier();
            this.hideGallery = this.shouldHideGallery();
            if (this.enableCashReward && this.isCashRewardAvailable()) {
                this.hideGallery = true;
            }
            const rewardsObj = this.rewardsResponseObj;
            this.setScoreCardValueInRewards(rewardsObj);
            this.showLoading = false;

            this.focusOnRewardGrid();

            this.initPointsRewardGrid();
            if (window['AB'] && window['AB']['DATALAYER'] && localStorage.getItem('analyticsTabClicked')) {
                window['AB']['DATALAYER'].initAngularSPA('rewards', 'dashboard', 'groceryrewards');
                localStorage.removeItem('analyticsTabClicked');
            }
        } else {
            this._showError();
        }
    }

    private resetCounters() {
        this.counter = [];
        this.currentCounter = [];
        this.count = {};
        this.currentCounter = {};
        this.catigorizePointsTierRewards = {};
    }

    private shouldHideGallery() {
        return this.hideGallery || (this.enableCashReward && this.isCashRewardAvailable());
    }

    private isCashRewardAvailable() {
        return this.cashReward?.length > 0 && this.cashReward[0].status === 'C';
    }


    private createToast(args): void {
        const toastElement: HTMLElement = this._rewardsToasterService.createToast(
            {message: args.message, type: args.type, autoCloseTime: RewardsToasterService.autoCloseTime},
            args.continueCb ? args.continueCb : () => {
            },
            args.closeCb ? args.closeCb : () => {
            },
            true
        );
        const contentElement = document.querySelector('.point-reward-grid-container');
        if (toastElement && contentElement) {
            this._renderer.appendChild(contentElement, toastElement);
        }
    }

    private focusOnRewardGrid() {
        if ($('reward-grid') && typeof $('reward-grid').ready !== 'undefined') {
            $('reward-grid').ready(() => {
                const focusItem = localStorage.getItem('rewardFocus');
                if (focusItem !== '') {
                    $(`[data-focus="${focusItem}"]`).focus();
                    localStorage.setItem('rewardFocus', '');
                }
            });
        }
    }
    setScoreCardValueInRewards(rewardsObj) {
        const rewards = rewardsObj?.rewards;

        this.autoRewardsPoints = 0;
        this.balance = 0;
        this.dollarDiscount = 0;
        this.willExpire = 0;
        this.isUserHasRewards = false;

        if (rewards) {
            this.autoRewardsPoints = rewards.autoRewardsPoints ?? 0;
            this.balance = rewards.balance ?? 0;
            this.dollarDiscount = rewards.dollarDiscount ?? 0;
            this.willExpire = rewards.willExpire ?? 0;
            this.isUserHasRewards = rewards.isUserHasRewards;

            if (this.isUserHasRewards && this.willExpire >= 0) {
                const expireText = this.willExpire == 1 ? 'expires ' : 'expire ';
                const dateAsOf = new Date();
                const displayDate = new Date(dateAsOf.getFullYear(), dateAsOf.getMonth() + 1, 0);
                this.rewardsPointsValueDetailsDisplay = this.willExpire === 1 ? `${this.willExpire.toLocaleString("en-US")} Point` : `${this.willExpire.toLocaleString("en-US")} Points`;
                this.rewardsPointsDateDetailsDisplay = expireText + `${displayDate.toLocaleString('default', { month: 'short' })} ${displayDate.getDate()}`;
            }
        }

        this.rewards.forEach(reward => {
            reward.rewardsAvailable = Math.floor(this.balance / 100);
            reward.pointsAvailable = this.balance;
            reward.rewardsExpire = this.willExpire;
        });
    }
    public counterRewardsRequired() {
        this.rewards.forEach(reward => {
            if (!this.counter.includes(reward.rewardsRequired)) {
                return this.counter.push(reward.rewardsRequired);
            }
        });

        this.counter.sort((a, b) => {
            return a < b ? -1 : a > b ? 1 : 0;
        });
    }

    public counterTempRewardsRequired() {
        this.tempCounter = [];
        this.rewardsSecondary.forEach(reward => {
            if (!this.tempCounter.includes(reward.rewardsRequired)) {
                return this.tempCounter.push(reward.rewardsRequired);
            }
        });

        this.counter.sort((a, b) => {
            return a < b ? -1 : a > b ? 1 : 0;
        });
    }

    public rewardsCount() {
        this.sortedRewards.forEach(reward => {
            if (this.count[reward.rewardsRequired]) {
                this.count[reward.rewardsRequired] += 1;
            } else {
                this.count[reward.rewardsRequired] = 1;
            }
        });
        return this.count;
    }

    public currentRewardsCount() {
        this.currentCounter = {};
        this.rewardsSecondary.forEach(reward => {
            if (this.currentCounter[reward.rewardsRequired]) {
                this.currentCounter[reward.rewardsRequired] += 1;
            } else {
                this.currentCounter[reward.rewardsRequired] = 1;
            }
        });
        return this.currentCounter;
    }

    public sortRewards() {
        this.sortedRewards = this.rewards.sort((a, b) => (a.rewardsRequired - b.rewardsRequired) || (a.specialRank - b.specialRank));
        return this.sortedRewards;
    }

    private catigorizeRewardstoPointsTier() {

        this.sortedRewards = this.rewards.sort((a, b) => (a.pointsRequired - b.pointsRequired) || (a.specialRank - b.specialRank));
        this.catigorizePointsTierRewards = this.sortedRewards.reduce((acc, curr) => {
            if (curr.pointsRequired) {
                if (!acc[curr.pointsRequired.toString()]) {
                    acc[curr.pointsRequired.toString()] = [];
                }
                acc[curr.pointsRequired.toString()].push(curr);
            }
            return acc;
        }, {});

    }

    private isObjectEmpty(obj: any): boolean {
        return obj && Object.keys(obj).length > 0;
    }

    pointComparator = (a, b): number => {
        return +a.key > +b.key ? 1 : (+b.key > +a.key ? -1 : 0);
    }

    private initPointsRewardGrid() {
        var userPoints = this.balance; // [50,100, 200] 138
        let keys = Object.keys(this.catigorizePointsTierRewards);
        let currentkey = 0;
        let position = keys.length;
        for (let i = keys.length; i >= 0; i--) {
            let key = Number(keys[i]);
            if (userPoints >= key) {
                currentkey = key;
                position = i;
                break;
            }
        }
        if (userPoints == 0 || currentkey == 0) {
            var currentPointTier = Object.keys(this.catigorizePointsTierRewards)[0];
            this.currentPointTier = currentPointTier;
            this.resetLoadMoreRewards(this.currentPointTier);
            // setTimeout(() => {
            //     var firstClassName = document.getElementsByClassName('tierButton')[0];
            //     firstClassName.classList.add('tierSelected');
            //     firstClassName.scrollIntoView();
            // }, 1000)
        } else {
            this.currentPointTier = currentkey.toString();
            this.resetLoadMoreRewards(this.currentPointTier);
            // setTimeout(() => {
            //     var firstClassName = document.getElementsByClassName('tierButton')[position];
            //     firstClassName.classList.add('tierSelected');
            //     firstClassName.scrollIntoView();
            // }, 1000)
        }
    }

    public setupPointsRewardGrid(tier, clickedButton) {
        this.currentPointTier = tier;
        this.resetLoadMoreRewards(this.currentPointTier);
    }

    private resetLoadMoreRewards(tier) {
        if (this.catigorizePointsTierRewards[tier].length > 0) {
            let displayCount = 0;
            if (window.innerWidth < 768) {
                displayCount = 30;
            } else if (window.innerWidth >= 768 && window.innerWidth <= 992) {
                displayCount = 30;
            } else if (window.innerWidth > 992) {
                displayCount = 30;
            }
            const tempArray = [];
            if (this.catigorizePointsTierRewards[tier].length <= displayCount) {
                displayCount = this.catigorizePointsTierRewards[tier].length;
            }
            this.sortedRewards = this.catigorizePointsTierRewards[tier];
            this.sortedRewards.slice(0, displayCount).forEach(item => {
                tempArray.push(item);
            });
            this.rewardsSecondary = [];
            this.rewardsSecondary = [...tempArray];
        }
        return this.rewardsSecondary;
    }

    private loadMoreTierRewards() {
        this.isLoadMoreActive = true;
        this.showLoader();
        this.rewardsSecondary = this._paginationService.loadRewards(this.sortedRewards, this.rewardsSecondary.length, this.isLoadMoreActive);
        this.isLoadMoreActive = false;
        this.hideLoader();
    }

    /**
     * Replace reward's content with generic error message.
     *
     */
    private _showError() {
        this.showLoading = false;
        this.error = true;
        this.errorMessage = 'Sorry, we\'re having technical difficulties and working on fixing them, please check back later.';
        if (window['AB'] && window['AB']['DATALAYER']) {
            window['AB']['DATALAYER'].setError('no-value', 'grocery-rewards|error', this.errorMessage);
        }
    }

    /**
     * Show sign in modal to unregistered users.
     */
    private _showSignInModal(): void {
        if (window['SWY']['CONFIGSERVICE'] && window['SWY']['CONFIGSERVICE'].featureToggleConfig && window['SWY']['CONFIGSERVICE'].featureToggleConfig.enableWebOTP) {
            window['AB']['COMMON'].showSignInModal_OTP();
        } else {
            window['AB']['COMMON'].showCreateAccontModalJ4U();
        }
    }

    public isRewardExpired(reward) {
        const currentDate = new Date();
        const day = currentDate.getDay();
        const month = currentDate.getMonth();
        const year = currentDate.getFullYear();
        const datestring = `${month}/${day}/${year}`;
        const finalDate = new Date(datestring);

        const rewardEndDateTokens = reward.displayEndDate.split('/');
        const rewardEndDate = new Date(`
            ${rewardEndDateTokens[0]}/
            ${rewardEndDateTokens[1]}/
            ${rewardEndDateTokens[2]}
        `);
        return rewardEndDate < finalDate;
    }

    private initLoadRewards() {
        if (this.sortedRewards.length > 0) {
            let displayCount = 30;
            const tempArray = [];
            if (this.rewardsSecondary.length > displayCount) {
                displayCount = this.rewardsSecondary.length;
            }
            this.sortedRewards.slice(0, displayCount).forEach(item => {
                tempArray.push(item);
            });
            this.rewardsSecondary = [...tempArray];
        }
        this.currentRewardsCount();
        this.counterTempRewardsRequired();
        return this.rewardsSecondary;
    }

    private showLoader(): void {
        this._loaderService.show();
    }

    private hideLoader(): void {
        this._loaderService.hide();
    }

    private loadMoreRewards() {
        this.isLoadMoreActive = true;
        this.showLoader();
        this.rewardToFocus = this.rewardsSecondary ? this.rewardsSecondary.length : 0;
        this.rewardsSecondary = this._paginationService.loadCoupons(this.sortedRewards, this.isLoadMoreActive);
        this.isLoadMoreActive = false;
        this.hideLoader();
        this.focusReward();
        this.currentRewardsCount();
        this.counterTempRewardsRequired();
    }

    handleKeydown(event: KeyboardEvent, pointTier: any) {
        const tabs = this.tabsList.nativeElement.querySelectorAll('[role="tab"]');
        const index = Array.prototype.indexOf.call(tabs, event.target);
        let newIndex = -1;

        switch (event.key) {
            case 'ArrowRight':
                newIndex = (index + 1) % tabs.length;
                break;
            case 'ArrowLeft':
                newIndex = (index - 1 + tabs.length) % tabs.length;
                break;
            case 'Home':
                newIndex = 0;
                break;
            case 'End':
                newIndex = tabs.length - 1;
                break;
            case 'Enter':
            case ' ':
                this.setupPointsRewardGrid(pointTier, event);
                return;
            default:
                return;
        }
        tabs[newIndex].focus();
        event.preventDefault();
    }

    private hideloadMoreBtn() {
        this.hideloadMoreButton = false;
        if (this.rewardsSecondary.length === this.sortedRewards.length) {
            this.hideloadMoreButton = true;
        }
        return this.hideloadMoreButton;
    }

    private focusReward() {
        setTimeout(() => {
            const productFocusElem = $('reward-item')[this.rewardToFocus];
            if (productFocusElem && $(productFocusElem)) {
                $(productFocusElem).find('.grid-reward-heading-offer-price').focus();
            }
        }, 500);
    }

}
